// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"262":"component---src-pages-docs-mdx-slug-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"262":"49ec5e98b5b037ed012a","678":"954575ea0ee9b0e3eab5","883":"62ed56fde0c4fd65dfe6"}[chunkId] + ".js";
};